import { InjectionToken } from '@angular/core';
import { Status } from '@df/core/status';

export const PWA_SERVICE = new InjectionToken<IPwaIntegration>('PWA_SERVICE');

export interface IPwaIntegration {
    isStandalone(): boolean;
    toggleForcedStandalone(to: boolean): void;
    isAvailable: boolean;
    toggleStatus?: Status;
}
